module.exports = __webpack_public_path__ + "img/sell-coins.f27f05b2.png";